//@flow
export const organizationsActionTypes = {
  LOAD_ORGANIZATIONS: "LOAD_ORGANIZATIONS",
  SELECT_ORGANIZATION: "SELECT_ORGANIZATION",
  CLEAR_ORGANIZATIONS: "CLEAR_ORGANIZATIONS",
};

export type OrganizationsActionType = $Keys<typeof organizationsActionTypes>;
